import { useI18n } from '@/i18n/i18n-context'
import type { TranslationKey } from '@/i18n/translations'
import { Button } from '@/ui/button'
import { Card } from '@/ui/card'

interface Props {
  /** A translation key, never a sentence: nothing a patient reads is chosen by the caller. */
  readonly messageKey: TranslationKey
  readonly onRetry: () => void
}

export function ScanFailedScreen({ messageKey, onRetry }: Props) {
  const { t } = useI18n()
  return (
    <Card className="flex flex-col gap-3 text-center">
      <h1 className="text-lg font-semibold text-slate-900">{t('scanFailed')}</h1>
      <p className="text-sm text-slate-600">{t(messageKey)}</p>
      <Button onClick={onRetry}>{t('tryAgain')}</Button>
    </Card>
  )
}
